// Shared constants and animation presets for homepage sections.

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const PHONE_RAW = "7123109514";
export const PHONE_DISPLAY = "(712) 310-9514";
export const SMS_HREF = `sms:+1${PHONE_RAW}?body=Gutters`;
export const TEL_HREF = `tel:+1${PHONE_RAW}`;

// ----------------------------------------------------------------------------
// PRICING TIERS — single source of truth.
// Each tier is active until its `until` timestamp; once `now` >= `until`,
// the next tier takes over. After the last timed tier, STANDARD_TIER applies.
// Iowa is Central Time. CDT = UTC-5 (DST). All timestamps below are UTC.
// ----------------------------------------------------------------------------
export const PRICING_TIERS = [
  {
    id: "may-special",
    until: new Date("2026-05-31T22:00:00Z"), // 5:00 PM CDT, May 31, 2026
    promoBadgeLabel: "Urgent",
    promoBadgeClass: "text-[#FF5C5C] animate-pulse",
    promoText: "Last day to schedule at May pricing — $50 single-story · $75 two-story",
    promoCtaText: 'Text "Gutters" now',
    promoCtaClass: "text-[#B8FF8C] font-bold",
    heroBadge: "May: $50 single · $75 two-story",
    menuPrice: "$50 / $75",
    menuSubtext:
      "May special · single-story / two-story · $100 returns June 1",
  },
  {
    id: "june-week-1",
    until: new Date("2026-06-08T05:00:00Z"), // 12:00 AM CDT, June 8, 2026
    promoBadgeLabel: "June Week 1 Special",
    promoBadgeClass: "text-[#B8FF8C]",
    promoText: "Gutter cleanings $90 flat — first week of June only",
    promoCtaText: 'Text "Gutters" to book',
    promoCtaClass: "hover:text-white",
    heroBadge: "June Week 1: $90 flat per home",
    menuPrice: "$90",
    menuSubtext:
      "Limited-time June Week 1 rate · $95 next week · $100 returns June 15",
  },
  {
    id: "june-week-2",
    until: new Date("2026-06-15T05:00:00Z"), // 12:00 AM CDT, June 15, 2026
    promoBadgeLabel: "June Week 2 Special",
    promoBadgeClass: "text-[#B8FF8C]",
    promoText: "Gutter cleanings $95 flat — last week of June savings",
    promoCtaText: 'Text "Gutters" to book',
    promoCtaClass: "hover:text-white",
    heroBadge: "June Week 2: $95 flat per home",
    menuPrice: "$95",
    menuSubtext:
      "Limited-time June Week 2 rate · $100 standard returns June 15",
  },
  {
    id: "rest-of-june-80",
    until: new Date("2026-07-01T05:00:00Z"), // 12:00 AM CDT, July 1, 2026
    promoBadgeLabel: "Rest of June Special",
    promoBadgeClass: "text-[#B8FF8C]",
    promoText: "Gutter cleanings $80 flat — through the end of June",
    promoCtaText: 'Text "Gutters" to book',
    promoCtaClass: "hover:text-white",
    heroBadge: "Rest of June: $80 flat per home",
    menuPrice: "$80",
    menuSubtext:
      "Limited-time rest-of-June rate · $100 standard returns July 1",
  },
];

export const STANDARD_TIER = {
  id: "standard",
  until: null,
  promoBadgeLabel: "Neighbor Special",
  promoBadgeClass: "text-[#B8FF8C]",
  promoText:
    "$100 flat per home — 2 neighbors on the same block for $150",
  promoCtaText: 'Text "Gutters" to book',
  promoCtaClass: "hover:text-white",
  heroBadge: "$100 flat rate · $150 for 2 neighbors",
  menuPrice: "$100",
  menuSubtext:
    "Flat rate per home · 2 neighbors on the same block = $150 total",
};

export function getCurrentTier() {
  const now = new Date();
  for (const tier of PRICING_TIERS) {
    if (now < tier.until) return tier;
  }
  return STANDARD_TIER;
}

// ----------------------------------------------------------------------------

export const SERVICE_AREAS = [
  "Glenwood",
  "Pacific Junction",
  "Malvern",
  "Silver City",
  "Mineola",
  "Hastings",
  "Tabor",
  "Stanton",
  "Shenandoah",
  "Essex",
  "Council Bluffs",
  "Logan",
  "Woodbine",
  "Dunlap",
  "Emerson",
  "Red Oak",
  "New Market",
  "Bedford",
];

export const reveal = {
  initial: { opacity: 0, y: 24 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-80px" },
  transition: { duration: 0.6, ease: [0.22, 1, 0.36, 1] },
};

export const INITIAL_CONTACT_FORM = {
  name: "",
  phone: "",
  email: "",
  address: "",
  service_type: "",
  preferred_date: "",
  preferred_time_window: "",
  message: "",
};

export const TIME_WINDOW_OPTIONS = [
  { value: "08:00", label: "8:00 AM – 9:00 AM" },
  { value: "09:00", label: "9:00 AM – 10:00 AM" },
  { value: "10:00", label: "10:00 AM – 11:00 AM" },
  { value: "11:00", label: "11:00 AM – 12:00 PM" },
  { value: "12:00", label: "12:00 PM – 1:00 PM" },
  { value: "13:00", label: "1:00 PM – 2:00 PM" },
  { value: "14:00", label: "2:00 PM – 3:00 PM" },
  { value: "15:00", label: "3:00 PM – 4:00 PM" },
  { value: "16:00", label: "4:00 PM – 5:00 PM" },
  { value: "17:00", label: "5:00 PM – 6:00 PM" },
  { value: "18:00", label: "6:00 PM – 7:00 PM" },
  { value: "flexible", label: "Flexible — anytime that day" },
];
